import React, { Component } from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/SearchActions';
import * as apiActions from '../../actions/ApiActions';

import SearchHeader from '../../components/SearchHeader/SearchHeader'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import LogoCarousel from "../../components/LogoCarousel/LogoCarousel";
import PhotoSlider from "../../components/PhotoSlider/PhotoSlider";
import HeaderLink from '../../components/HeaderLink/HeaderLink';
import ContactForm from '../../components/ContactForm/ContactForm';
import Content from '../../components/Content/Content';

class ContactContainer extends Component {

  render() {
    const { sendContactMessage } = this.props;

    return (
      <Content>

        <Section grey>
          <Row>
            <Col md={5} xs={12}>
              <Headline>Haben Sie noch Fragen?</Headline>
              <Headline small>Dann kommen Sie mit uns in Kontakt.</Headline>
              <ContactForm sendAction={(body) => sendContactMessage(body)} />
            </Col>

            <Col md={{ size: 5, offset: 1 }} xs={12}>
              <div style={{ display: 'flex', width: '100%', height: '100%', justifyContent: 'flex-end', flexDirection: 'column' }}>
                <Headline>Bekannt aus:</Headline>
                <img src={'/img/bekannt-aus.png'} />
              </div>
            </Col>
          </Row>

        </Section>

      </Content>
    )
  }
}

function mapStateToProps(state) {
  return {
    fachgruppen: state.fachgruppen,
    searchQuery: state.searchQuery
  };
}

export default connect(mapStateToProps, {...actions, ...apiActions})(ContactContainer);



// WEBPACK FOOTER //
// ./src/container/public/ContactContainer.js